import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Linkedin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-brand-blue text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img 
                src="https://customer-assets.emergentagent.com/job_foodholdings/artifacts/1p6ljk80_tengfoodholdings-logo.png"
                alt="Teng Food Holdings"
                className="h-10 w-auto"
              />
              <div>
                <h3 className="text-lg font-bold">Teng Food Holdings</h3>
                <p className="text-sm text-brand-light">Food Manufacturing Excellence</p>
              </div>
            </div>
            <p className="text-brand-light text-sm">
              Over 20 years of expertise in food manufacturing, catering services, 
              and innovative culinary solutions across Singapore.
            </p>
            <div className="flex space-x-4">
              <Facebook className="h-5 w-5 text-brand-gray hover:text-brand-sky cursor-pointer transition-colors" />
              <Linkedin className="h-5 w-5 text-brand-gray hover:text-brand-sky cursor-pointer transition-colors" />
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-brand-coral">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-brand-light hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/businesses" className="text-brand-light hover:text-white transition-colors">Our Businesses</Link></li>
              <li><Link to="/expertise" className="text-brand-light hover:text-white transition-colors">Our Expertise</Link></li>
              <li><Link to="/oem-services" className="text-brand-light hover:text-white transition-colors">OEM Services</Link></li>
              <li><Link to="/contact" className="text-brand-light hover:text-white transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          {/* Our Companies */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-brand-coral">Our Companies</h4>
            <ul className="space-y-2">
              <li><Link to="/businesses/first-cuisine" className="text-brand-light hover:text-white transition-colors">First Cuisine (Halal)</Link></li>
              <li><Link to="/businesses/ps-catering" className="text-brand-light hover:text-white transition-colors">PS Catering (Non-Halal)</Link></li>
              <li><Link to="/businesses/fc-industries" className="text-brand-light hover:text-white transition-colors">FC Food Industries</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-brand-coral">Contact Info</h4>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-brand-sky mt-0.5 flex-shrink-0" />
                <div className="text-sm text-brand-light">
                  <p className="font-medium">Head Office:</p>
                  <p>15 Senoko Drive #03-07/08<br />
                  JTC Food Hub @ Senoko<br />
                  Singapore 758202</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="h-5 w-5 text-brand-sky" />
                <a href="tel:+6569581668" className="text-sm text-brand-light hover:text-white transition-colors">
                  +65 6958 1668
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-brand-sky" />
                <a href="mailto:sales@firstcuisine.com.sg" className="text-sm text-brand-light hover:text-white transition-colors">
                  sales@firstcuisine.com.sg
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-brand-charcoal mt-8 pt-8 text-center">
          <p className="text-sm text-brand-gray">
            © {currentYear} Teng Food Holdings Pte Ltd. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;